<template>
  <div>
    <preloader :is-visible="loading"></preloader>
    <div class="uk-card uk-card-default">
      <!--шапка страницы-->
      <div class="uk-card-header" style="padding-top: 15px;padding-bottom: 15px;">
        <div class="uk-grid uk-flex-middle" data-uk-grid>
          <div class="uk-width-expand">
            <h3 class="uk-card-title uk-margin-remove-top">
              Аналитика по клиенту
            </h3>
          </div>
          <div>
            <div class="uk-grid uk-grid-small uk-flex-middle" data-uk-grid>
              <div>
                Client ID
              </div>
              <div class="uk-width-expand">
                <div class="uk-grid tm-grid-xsmall uk-flex-middle" data-uk-grid>
                  <div>
                    <input v-model="clientId" @keyup.enter.exact="getClientAnalytics" @keyup.ctrl.enter.exact="getClientAnalytics" class="uk-input" type="text" style="width: 300px;">
                  </div>
                  <div>
                    <md-icon class="tm-color-green">info</md-icon>
                    <div class="uk-dropdown tm-dropdown tm-dropdown-bottom-center"
                         style="width:500px;word-break: break-word;"
                         data-uk-dropdown="animation: uk-animation-slide-top-small; pos: bottom; delay-hide: 0; delay-show: 0; offset: 10">
                      <template v-for="(item,index) in clientInfo">
                        <div :key="index"> {{index}}: {{ item }} </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
<!--            ClientInfo-->
            <div v-if="false">
            <template v-for="(item,index) in clientInfo">
              <div :key="index"> {{index}}: {{ item }} </div>
            </template>
            </div>
          </div>
          <div>
            <date-picker
                v-model="period"
                :lang="lang"
                range
                type="datetime"
                confirm
                :show-second=false
                :show-time-header=true
                :show-week-number="true"
            />
          </div>
          <div>
            <div class="uk-grid uk-grid-small uk-flex-middle" data-uk-grid>
              <div>
                <button class="uk-button tm-button-grey uk-button-small" type="button">DB</button>
                <div class="uk-dropdown tm-dropdown tm-dropdown-bottom-center" data-uk-dropdown="animation: uk-animation-slide-top-small; pos: bottom; delay-hide: 0; delay-show: 0; offset: 15" style="width: 75px;max-width: 75px; min-width: 75px;">
                  <div class="uk-grid uk-grid-small uk-child-width-1-1" data-uk-grid>
                    <div v-for="(option, index) in sourceOptions" :key="index">
                      <div><label><input class="uk-checkbox" type="checkbox" v-model="selectedSourceOptions" :value="option.value" >&nbsp; {{ option.label }}</label></div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <button :disabled="!clientId || selectedSourceOptions.length === 0" @click.prevent="getClientAnalytics" class="uk-button uk-button-success uk-button-small" type="button">RUN</button>
              </div>
            </div>
          </div>
          <div>
            <select class="uk-select"
                    v-model="pagination.perPage"
                    name="perPage"
                    ref="perPage"
                    id="perPage"
                    v-on:change="changeListLength">
              <template v-for="item in pagination.perPageOptions">
                <option :label="item"
                        :value="item"
                        :key="item">
                  {{ item }}
                </option>
              </template>
            </select>
          </div>
        </div>
      </div>
      <div class="uk-card-body">
        <!--шапка таблицы-->
        <div class="uk-text-bold" style="background-color: #4caf50; color: #fff;" data-uk-sticky="start: 200; animation: uk-animation-slide-top">
          <div class="uk-grid uk-grid-collapse uk-text-center uk-flex-middle" data-uk-grid>
            <div class="uk-width-auto">
              <div style="width: 140px;" class="tm-padding-xsmall">
                <div class="uk-grid tm-grid-xsmall uk-flex-middle uk-flex-center" data-uk-grid>
                  <div>
                    Date
                  </div>
                  <!--Сортировка по ID-->
                  <div>
                    <a href="#" class="uk-display-inline-block uk-link-reset">
                      <span class="uk-icon" @click="setSortingData('1','asc')">
                        <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><polygon points="10.5,4 15.37,9.4 14.63,10.08 10.5,5.49 6.37,10.08 5.63,9.4"></polygon><line fill="none" stroke="#000" x1="10.5" y1="16" x2="10.5" y2="5"></line></svg>
                      </span>
                      <span class="uk-icon uk-link-reset" style="margin-left: -6px;" @click="setSortingData('1','desc')">
                        <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><polygon points="10.5,16.08 5.63,10.66 6.37,10 10.5,14.58 14.63,10 15.37,10.66"></polygon><line fill="none" stroke="#000" x1="10.5" y1="4" x2="10.5" y2="15"></line></svg>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="uk-width-expand">
              <div class="uk-grid uk-grid-collapse uk-flex-middle" data-uk-grid>
                <!--DB-->
                <div style="width: 60px;">
                  <div class="tm-padding-xsmall">
                    <div class="uk-grid tm-grid-xsmall uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        DB
                      </div>
                    </div>
                  </div>
                </div>
                <!--Event IN-->
                <div class="uk-width-1-2">
                  <div class="tm-padding-xsmall">
                    <div class="uk-grid tm-grid-xsmall uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        Event IN
                      </div>
                    </div>
                  </div>
                </div>
                <!--Event OUT-->
                <div class="uk-width-expand">
                  <div class="tm-padding-xsmall">
                    <div class="uk-grid tm-grid-xsmall uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        Event OUT
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--таблица-->
        <div>
          <template v-for="(log,index) in logs">
            <div :key="index">
              <div class="uk-grid uk-grid-collapse uk-text-center uk-flex-middle tm-grid-bg-hover uk-text-small" :class="getColorByLabel(log[2])" data-uk-grid>
                <div class="uk-width-auto">
                  <div style="width: 140px;" class="tm-padding-xsmall">
                    {{log[1]}}
                  </div>
                </div>
                <div class="uk-width-expand">
                  <div class="uk-grid uk-grid-collapse uk-flex-middle" data-uk-grid>
                    <!--DB-->
                    <div style="width: 60px;">
                      <div class="tm-padding-xsmall">
                        <div>
                          {{log[2]}}
                        </div>
                        <div v-if="log[2.1]" class="uk-dropdown tm-dropdown tm-dropdown-bottom-center"
                             style="width:300px"
                             data-uk-dropdown="animation: uk-animation-slide-top-small; pos: bottom; delay-hide: 0; delay-show: 0; offset: 10">
                          {{log[2.1]}}
                        </div>
                      </div>
                    </div>
                    <!--Event IN-->
                    <div class="uk-width-1-2">
                      <div class="tm-padding-xsmall uk-text-left" @click="handleClick">
                        <div class="uk-grid tm-grid-small uk-flex-middle" data-uk-grid>
                          <div class="uk-width-auto" v-if="log[3.1] !==' ' && log[3.1]">
                            <md-icon class="tm-color-green">info</md-icon>
                            <div class="uk-dropdown tm-dropdown tm-dropdown-bottom-center"
                                 style="width:400px;word-break: break-word;"
                                 data-uk-dropdown="animation: uk-animation-slide-top-small; pos: bottom; delay-hide: 0; delay-show: 0; offset: 10">
                              {{log[3.1]}}
                            </div>
                          </div>
                          <div class="uk-width-auto" v-if="log['image_url']" @click="openUpcImage(log)">
                            <md-icon v-if="log[2] === 'UPC'" class="tm-color-green" style="cursor: pointer">image</md-icon>
                            <md-icon v-else class="" style="cursor: pointer">phone_iphone</md-icon>
                          </div>
                          <div class="uk-width-expand" >
                            <div class="uk-text-truncate" v-html="formatOrderNumber(log[3])"></div>
                            <div class="uk-dropdown tm-dropdown tm-dropdown-top-center"
                                 style="width:400px;word-break: break-word;"
                                 data-uk-dropdown="animation: uk-animation-slide-top-small; pos: top; delay-hide: 0; delay-show: 0; offset: 10">
                              <template v-if="log[2] === 'FB'">
                                <div v-html="formatOrderNumber(log[3.2])"></div>
                              </template>
                              <template v-else>
                                <div v-html="formatOrderNumber(log[3])"></div>
                              </template>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--Event OUT-->
                    <div class="uk-width-expand">
                      <div class="tm-padding-xsmall uk-text-left">
                        <div class="uk-grid tm-grid-small uk-flex-middle" data-uk-grid>
                          <div class="uk-width-auto" v-if="log['4.1'] !== ' ' && log['4.1'] !== null ">
                            <md-icon class="tm-color-green">info</md-icon>
                            <div class="uk-dropdown tm-dropdown tm-dropdown-bottom-center"
                                 style="width:500px;word-break: break-word;"
                                 data-uk-dropdown="animation: uk-animation-slide-top-small; pos: bottom; delay-hide: 0; delay-show: 0; offset: 10">
                              {{log[4.1]}}
                            </div>
                          </div>
                          <div class="uk-width-expand">
                            {{log[4]}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr class="uk-margin-remove">
            </div>
          </template>
        </div>
        <!--результат поиска-->
        <div v-if="!pagination.totalPages" class="tm-padding-xsmall uk-text-center">
          Поиск не дал результатов
        </div>
        <!--Пагинация-->
        <ul v-if="pagination.lastPage > 1"  class="uk-pagination tm-pagination uk-flex-center uk-margin">
          <li :class="(pagination.currentPage <= 1 ? 'uk-disable tm-disabled' : '')">
            <a href="#" class="uk-link-reset" @click="goToPrevious">
              <span data-uk-pagination-previous></span>
            </a>
          </li>
          <template v-for="page in pagination.lastPage">
            <li :key="page" class="uk-active" v-if="pagination.currentPage === page">
            <span>
              {{ pagination.currentPage }}
            </span>
            </li>
            <li :key="page" @click="goToPage(page)" v-else>
              <a href="#" class="uk-link-reset">{{ page }}</a>
            </li>
          </template>
          <li :class="(pagination.currentPage >= pagination.lastPage ? 'uk-disable tm-disabled' : '')">
            <a href="#" class="uk-link-reset" @click="goToNext">
              <span data-uk-pagination-next></span>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <!--иифо диалоговое окно - детали заказа-->
    <md-dialog
        :md-active.sync="showDialog"
        :md-closed="true"
        :md-clicked-outside="true"
        :md-close-on-esc="true"
        class="tm-dialog-progress-report">
      <div class="uk-padding uk-position-relative tm-modal-page" style="overflow-y: scroll;">
        <a class="uk-position-top-right tm-dialog-close" @click="showDialog = false" style="cursor: pointer">
          <span class="material-icons">close</span>
        </a>
        <div class="uk-grid uk-flex-middle" data-uk-grid>
          <div class="uk-width-auto">
            <h4>{{ local_page_keys.order_number }}: {{ order_id }}</h4>
          </div>
          <div class="uk-width-expand">
            <div class="uk-grid uk-grid-small uk-flex-center uk-flex-middle" data-uk-grid>
              <div>
                <a href="#" :disabled="activeOrderKey <= 0"
                   class="tm-light tm-light-hover uk-button uk-button-small-padding uk-button-success" role="button"
                   data-uk-tooltip="title: Предыдущий заказ" @click="prevOrder">
                  <span class="material-icons">chevron_left</span>
                </a>
              </div>
              <div>
                <a href="#" :disabled="activeOrderKey >= (activeOrders.length-1)"
                   class="tm-light tm-light-hover uk-button uk-button-small-padding uk-button-success" role="button"
                   data-uk-tooltip="title: Следующий заказ" @click="nextOrder">
                  <span class="material-icons">chevron_right</span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="uk-margin" v-if="!activeOrderReload">
          <OrderView></OrderView>
          <hr class="uk-margin-medium">
          <h4 class="uk-margin">{{local_page_keys.title_previous_orders}}:</h4>
          <prev-orders-block-for-admin :currentOrderId="order_id"></prev-orders-block-for-admin>
        </div>
      </div>
    </md-dialog>

    <md-dialog
        :md-active.sync="showDialogPreviewUpc"
        :md-closed="true"
        :md-clicked-outside="true"
        :md-close-on-esc="true"
        class="">
      <div class="uk-padding uk-position-relative tm-modal-page" style="overflow-y: scroll;">
        <a class="uk-position-top-right tm-dialog-close" @click="showDialogPreviewUpc = false" style="cursor: pointer">
          <span class="material-icons">close</span>
        </a>
        <div class="uk-grid uk-flex-middle" data-uk-grid>
          <div class="uk-width-auto">
            <span v-if="loadingImageUpc" class="uk-icon uk-spinner"  data-uk-spinner="ratio: 2"></span>
            <img  v-else :src="imageViewUpc"  style="max-width: 700px" alt="No image">
          </div>
        </div>
      </div>
    </md-dialog>

  </div>
</template>

<script>
import Preloader from "../Components/Preloader";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/ru';
import OrderView from "@/pages/Dashboard/Pages/OrderView";
import PrevOrdersBlockForAdmin from "@/pages/Dashboard/Components/Admin/PrevOrdersBlockForAdmin";

export default {
  components: {Preloader, DatePicker, OrderView, PrevOrdersBlockForAdmin},
  name: 'ClientAnalytics',
  data() {
    return {
      loading: false,
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [50, 100, 500],
        totalPages:0,
        lastPage:0
      },
      clientId: '',
      sourceOptions: [
        {label: 'BO', value: 'bo', color: 'tm-client-analytics-table-color1'},
        {label: 'P', value: 'p', color: 'tm-client-analytics-table-color2'},
        {label: 'PE', value: 'pe', color: 'tm-client-analytics-table-color2'},
        {label: 'PO', value: 'po', color: 'tm-client-analytics-table-color2'},
        {label: 'OL', value: 'ol', color: 'tm-client-analytics-table-color3'},
        {label: 'APE', value: 'ape', color: 'tm-client-analytics-table-color3'},
        {label: 'AE', value: 'ae', color: 'tm-client-analytics-table-color3'},
        {label: 'UP', value: 'up', color: 'tm-client-analytics-table-color3'},
        {label: 'UPC', value: 'upc', color: 'tm-client-analytics-table-color3'},
        {label: 'FB', value: 'fb', color: 'tm-client-analytics-table-color4'},
      ],
      selectedSourceOptions: [],
      period: [],
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },
      clientInfo:{},
      logs:{},
      sort: {
        column: '1',
        order: 'asc'
      },
      showDialog: false,
      local_page_keys: {},
      activeOrderReload: false,
      activeOrderKey: null,
      activeOrders: [],
      order_id: null,
      imageViewUpc: null,
      showDialogPreviewUpc: false,
      loadingImageUpc: false
    };
  },
  methods: {
    async getClientAnalytics() {
      this.loading = true;
      let params = {
        period: JSON.stringify(this.period),
        clientId: this.clientId,
        perPage: this.pagination.perPage,
        page: this.pagination.currentPage,
        sources:  JSON.stringify(this.selectedSourceOptions),
        sort:  JSON.stringify(this.sort)
      }

      await this.$store.dispatch('clientAnalytics/clientAnalytics', params);
      let response = await this.$store.getters['clientAnalytics/clientAnalytics'];

      if (typeof response === 'object' && response.status === 200) {
        this.setDefaultPeriod(response.data.period)
        this.clientInfo = response.data.clientInfo;
        this.logs = response.data.logs.data;
        this.pagination.totalPages = response.data.logs.total;
        this.pagination.lastPage = response.data.logs.last_page;
      }
      else if (response.status === 422) {
        let errorMessages = Object.values(response.data.errors).flat();
        alert(errorMessages);
      }
      else {
        alert("error");
      }
      this.loading = false;
    },
    async setSortingData(field, sort) {
      if(!this.pagination.totalPages)
        return;
      this.sort.column = field;
      this.sort.order = sort;
      this.pagination.currentPage = 1;
      await this.getClientAnalytics();
    },
    async changeListLength() {
      await this.getClientAnalytics();
    },
    async goToPrevious() {
      this.pagination.currentPage--;
      await this.getClientAnalytics();
    },
    async goToNext() {
      this.pagination.currentPage++;
      await this.getClientAnalytics();
    },
    async goToPage(page) {
      this.pagination.currentPage = page;
      await this.getClientAnalytics();
    },
    setDefaultPeriod(period) {
      var currentDate = new Date(period[1]);
      var weekAgoDate = new Date(period[0]);
      this.period = [weekAgoDate, currentDate]
    },
    getColorByLabel(label) {
      const option = this.sourceOptions.find(option => option.label === label);
      return option ? option.color : '';
    },
    formatOrderNumber(text) {
      if (text)
        return text.replace(/\b\d{6}\b/g, match => `<a href="#${match}" class="uk-text-bold tm-link-visited-gray" data-order="${match}">${match}</a>`);

    },
    handleClick(event) {
      const target = event.target;
      if (target.tagName === 'A') {
        const orderNumber = target.getAttribute('data-order');
        if (orderNumber) {
        this.viewOrder(orderNumber);
        }
      }
    },
    async viewOrder(order_id) {
      this.activeOrderReload = true;
      await this.$store.dispatch('order/setViewOrderId', order_id);
      this.order_id = Number(order_id);
      this.showDialog = true;
      this.activeOrderReload = false;
      location.hash = order_id;
    },
    async nextOrder() {
      if (this.activeOrders[this.activeOrderKey + 1]) {
        await this.openOrder(this.activeOrders[this.activeOrderKey + 1]);
        this.activeOrderKey++;
      }
    },
    async prevOrder() {
      if (this.activeOrders[this.activeOrderKey - 1]) {
        await this.openOrder(this.activeOrders[this.activeOrderKey - 1]);
        this.activeOrderKey--;
      }
    },
    async openUpcImage(log) {
      if (log[2] === 'UPC') {
        let message = 'Открыть изображение и отправить данные?'
        this.imageViewUpc = null;
        if (confirm(message)) {
          let formData = new FormData();
          formData.append('upl_token', log['upl_token']);
          formData.append('chunks_cnt', log['chunks_cnt']);
          formData.append('upl_action', log['upl_action']);
          formData.append('upl_ID_client', log['upl_ID_client']);
          formData.append('origin_filename', log['origin_filename']);
          formData.append('not_delete_chunks', log['not_delete_chunks']);

          const url = 'https://orders.fixthephoto.com/tmp/ophotos/upl_chunk.php';
          const result = await fetch(url, {
            method: 'post',
            headers: {},
            body: formData,
          })

          const data = await result.json();
          if (result.status === 400 || result.status === 403) {
            await this.$store.dispatch(
                "alerts/error",
                data.error_txt
            );
          } else if (result.status === 200) {
            const keyValueString = Object.entries(data.upl_files)
                .map(([key, value]) => `${key}: ${value}`)
                .join('<br>');

            await this.$store.dispatch(
                "alerts/success",
                keyValueString
            );
          }
          await this.fetchImageViewUpc(log['image_url'])
        }

      } else if (log[2] === 'FB') {
        await this.fetchImageViewUpc(log['image_url'])
      }
    },
    async fetchImageViewUpc(url) {
      this.showDialogPreviewUpc = true;
      this.loadingImageUpc = true;
      const maxAttempts = 5;
      let attempts = 0;
      const fetchData = () => {
        fetch(url)
            .then(response => {
              if (response.status === 200) {
                this.imageViewUpc = url;
                this.loadingImageUpc = false;
              } else if (attempts < maxAttempts) {
                attempts++;
                setTimeout(() => {
                  fetchData();
                }, 2000);
              } else {
                alert('Достигнуто максимальное количество попыток')
                this.loadingImageUpc = false;
              }
            })
            .catch(error => {
              if (attempts < maxAttempts) {
                attempts++;
                setTimeout(() => {
                  fetchData();
                }, 2000);
              } else {
                alert('Достигнуто максимальное количество попыток')
                this.loadingImageUpc = false;
              }
            })
      };
      fetchData();
    },
    async initClient() {
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);
      this.clientId = params.get('clientId');

      if (!this.clientId)
        return

      this.pagination.perPage = params.get('perPage');

      let date_start = params.get('date_start')
      let date_end = params.get('date_end')

      if (date_start  && date_end) {
        this.setDefaultPeriod([date_start, date_end])
      }
      await this.getClientAnalytics();

    }
  },
  computed: {},
  async created() {
    this.selectedSourceOptions = this.sourceOptions.map(option => option.value);
    await this.getClientAnalytics();
    this.local_page_keys = await this.$filtergetLocalisationPages(['admin_orders_history','pro_retoucher_progress_report']);
    this.initClient()
  },
}
</script>

<style>
/*цвет для BO*/
.tm-client-analytics-table-color1 {

  background-color: rgb(252, 229, 205, 0.4);
}
/*цвет для P / PE / PO*/
.tm-client-analytics-table-color2 {
  background-color: rgba(166,77,121, 0.15);
}
/*цвет для APE / AE / UP / UPC / для OL*/
.tm-client-analytics-table-color3 {

}
/*цвет для FB*/
.tm-client-analytics-table-color4 {
  background-color: rgba(180, 183, 180, 0.15);
}
</style>